import { TitleBar } from '../components/TitleBar';
import '../assets/Home.css';
import { UpcomingEvents } from '../components/UpcomingEvents';

const adultXVsEvents = [
    {
        date: 'Nov 23rd',
        event: 'XVs Pre-Season Match #1 vs. SMC'
    },
    {
        date: 'Jan 4th',
        event: `Women's 10s vs All Blues`
    },
    {
        date: 'Jan 25th',
        event: 'XVs Season Starts'
    },
    {
        date: 'April 26th',
        event: 'XVs Regionals - Las Vegas, NV'
    },
    {
        date: 'May 16th - 18th',
        event: 'XVs Nationals - Indianapolis, IN'
    },
];

const adult7sEvents = [
    {
        date: 'Jun 14th',
        event: `Pat Vincent 7's`
    },
    {
        date: 'Jun 21st',
        event: `Marin 7's`
    },
    {
        date: 'Jun 28th',
        event: `Silicon Valley 7's`
    },
    {
        date: 'Jul 12th',
        event: `CA Grizzlies 7's`
    },
    {
        date: 'Jul 19th',
        event: `NCRFU 7's Chanmpionship`
    },
    {
        date: 'Jul 26th',
        event: `EPA 7's`
    },
    {
        date: 'Aug 2nd',
        event: `Tessie 7's`
    },
]

const hsEvents = [
    {
        date: 'March 8th',
        event: 'Season Starts'
    },
    {
        date: 'May 10th',
        event: 'Championships'
    },
];

const youthSeasonEvents = [
    {
        date: 'May 5th',
        event: 'Pre-season training starts, Mondays & Thursdays'
    },
    {
        date: 'June 7th',
        event: 'Tournament Season Begins (location TBD)'
    },
    {
        date: 'June 14th',
        event: 'Silicon Valley Rugby Sevens - Fair Oaks Park, Sunnyvale, CA'
    },
    {
        date: 'June 21st',
        event: 'location TBD'
    },
    {
        date: 'June 29th',
        event: 'location TBD'
    },
    {
        date: 'July 12th',
        event: 'Rugby NorCal Sevens Championship (location TBD)'
    },
    {
        date: 'July 21st',
        event: 'California State Games - San Diego, CA'
    },
    {
        date: 'July 28th',
        event: 'North American Invitational 7s'
    },
];


export const HomePage = () => {
    return (
        <div className='home-wrapper'>
            <TitleBar title='Home'/>
            <div className='title'>Fall Rugby is Here!</div>
            <h3>Men & Women</h3>
            <p>Training: 7:00 PM, Mondays & Thursdays</p>
            <p>
                Washington Park<br></br>
                840 W Washingtion Ave<br></br>
                Sunnyvale, CA 94086
            </p>
            
            <h3>Youth (U8-Middle School)</h3>
            <p>Middle School and Under-12 start training Monday, November 10th</p>
            <p>Under-10 and Under-8 start with something new this year: Try On Rugby - a one-month flag rugby activity.</p>
            <p>Come out and give rugby a try, starting Monday, November 10th, 6 PM.</p>
            <p>Register now! <a href="https://www.siliconvalleyrugby.org/registration/youth">https://www.siliconvalleyrugby.org/registration/youth</a></p>

            <h3>High School</h3>
            <p>To keep up with all communication with the high school team please download the <a href="https://www.sportsyou.com/">SportsYou App</a>.</p>
            <p>The team code is "PWF89BQR"</p>

            <div className='title'>Additional ways to be involved with SV</div>
            <p>Buy Silicon Valley Rugby logo gear at our <a href="https://www.worldrugbyshop.com/collections/silicon-valley-high-school-mens-rugby-club/">Pro Shop</a> by World Rugby Shop: All purchases at the shop rebate 10% of the list price to Silicon Valley Rugby. Support Silicon Valley in spirit and by raising funds.</p>
            <p>A note: Canterbury Clothing Company (CCC) garments tend to feature a modern, athletic fit. Some perceive that as running “small”. If you are considering an XL or larger size, consider sizing up.</p> 
            <p>A great way to be stay involved with SV Rugby is by becoming a donor or sponsor, SV is a 501(c)(3) nonprofit organization.</p>
            <p>If you have interest in donating or becoming a sponsor, please reach out.</p>
            <p>Thank you for all the support. GO SV!!</p>
            <div className='title'>Silicon Valley Rugby</div>
            <p>Silicon Valley RFC is a rugby club based in Silicon Valley, California, founded in 1998, as an Eagle Scout project creating our High School side. Our club offers junior youth, high school and adult rugby programs.</p> 
            <p>Our club mission, "To have a positive impact on peoples lives, through a thriving rugby club and community in Silicon Valley"</p>
            <p>Our club Core Values are:</p>
            <ul>
                <li>Community - Out of many, One</li>
                <li>Selflessness - we strive for the greater good of the club and community</li>
                <li>Focus - we are always moving forward</li>
                <li>Accountability - we adhere to the highest standard</li>
            </ul>
            <p>SVRFC is a non-profit Federal EIN: 27-0621542</p>
            {/* <UpcomingEvents title={`'24 / '25 Adults XVs Schedule`} events={adultXVsEvents} /> */}
            {/* <UpcomingEvents title={`2025 Adults 7s Schedule`} events={adult7sEvents} />
            <UpcomingEvents title={`'24 / '25  XVs Season - High School`} events={hsEvents} /> */}
            
            {/* <h3>'24 / '25  Youth & HS 7s Season - U8, U10, U12, U14 (Middle School), U16, U18 (High School)</h3>
            <UpcomingEvents title={`Match season:`} events={youthSeasonEvents} /> */}
        </div>
    );
}